import styled from 'styled-components';
import { webKitScrollbar } from '../scrollbars'

const Container = styled.div`
  background: ${p => p.theme.color.backgroundRush};
  border-radius: 25px;
  ${webKitScrollbar};
  max-height: 70%;
  &, * {
    box-sizing: border-box;
  }
  h6 {
    line-height: 30px;
  }
`;

const ThemeToneFrameContainer = styled.div`
  width: 150px;
  height: 150px;
  padding: 20px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${p => p.color};
  margin: 0 40px 40px 0;
  cursor: pointer;
  border: 5px solid
  ${p => (p.currentTone ? p.theme.color.turquoise : 'transparent')};
  :nth-child(4n) {
    margin-right: 0;
  }
  transition: all ${p => p.theme.duration.s} linear;
  :hover {
    transform: translateY(-5px);
  }
  :active {
    transform: scale(0.95);
  }
`;

const ThemeToneFrameBorder = styled.div`
  width: 100px;
  height: 15px;
  border-radius: 5px;
  background: ${p => p.color};
`

const ThemeHeader = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  padding: 0 60px;
  svg {
    height: 20px;
    width: 20px;
    fill: ${p => p.theme.color.turquoise};
    margin-right: 20px;
  }
`

const ThemeTonesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ThemeTonesHeader = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;
  padding: 0 60px;
  svg {
    height: 20px;
    width: 20px;
    fill: ${p => p.theme.color.turquoise};
    margin-right: 20px;
  }
`

const FramesContainer = styled.div`
  width: 100%;
  display: inline-flex;
  flex-wrap: wrap;
  padding: 40px 60px 20px 60px;
`

const Themes = styled.div`
  width: 840px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const Header = styled.div`
  width: 100%;
  display: inline-flex;
  padding: 60px 60px 40px 60px;
  svg {
    height: 30px;
    width: 30px;
    fill: ${p => p.theme.color.gray};
    margin-right: 30px;
  }
`


export const Styled = {
  Container,
  ThemeToneFrameContainer,
  ThemeToneFrameBorder,
  FramesContainer,
  ThemeHeader,
  ThemeTonesContainer,
  ThemeTonesHeader,
  Themes,
  Header,
};
